import Vue from 'vue'

export const state = () => ({
  duration: -1,
  distance: 0,
  positions: {},
  etas: {},
  geofences: [],
  devices: [],
  startColor: 'rgba(255, 100, 100, 1)',
  onColor: '#3D993D',
  endColor: 'black',
  session: null,
  position: null,
  address: '',
  currentTime: new Date()
})

export const getters = {
  address: state => state.address,
  duration: state => state.duration,
  distance: state => state.distance,
  geofences: state => state.geofences,
  devices: state => state.devices,
  startColor: state => state.startColor,
  onColor: state => state.onColor,
  endColor: state => state.endColor,
  end: state => state.session.attributes.linkVersion && state.session.attributes.linkVersion.split(','),
  endAddress: state => state.session && state.session.attributes && state.session.attributes.endAddress,
  allowedStartTime: state => state.session && state.session.attributes && state.session.attributes.allowedStartTime,
  allowedEndTime: state => state.session && state.session.attributes && state.session.attributes.allowedEndTime,
  allowedWeekDays: state => getAllowedWeekDays(state),
  isAllowedAccess: (state, getters) => getters.isAllowedTime && getters.isAllowedWeekDay,
  isAllowedTime: (state) => {
    const startTime = state.session && state.session.attributes && state.session.attributes.allowedStartTime
    const endTime = state.session && state.session.attributes && state.session.attributes.allowedEndTime
    if (!startTime || !endTime) {
      return true
    }
    const current = toMinutes(new Date(state.currentTime))
    const start = timeToMinutes(startTime)
    const end = timeToMinutes(endTime)
    return start <= end
      ? current >= start && current <= end
      : current >= start || current <= end
  },
  isAllowedWeekDay: (state) => {
    const allowedWeekDays = getAllowedWeekDays(state)
    if (!allowedWeekDays) {
      return true
    }
    const currentDay = weekDayKeys[new Date(state.currentTime).getDay()]
    return allowedWeekDays.includes(currentDay)
  },
  position: state => state.position,
  positions: state => Object.values(state.positions),
  positionByDevice: state => deviceId => state.positions[deviceId],
  etaByDevice: state => deviceId => state.etas[deviceId],
  start: state => state.position && [state.position.longitude, state.position.latitude],
  device: state => state.devices && state.devices[0] && state.devices[0].name
}

const weekDayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

function getAllowedWeekDays (state) {
  const allowedWeekDays = state.session && state.session.attributes && state.session.attributes.allowedWeekDays
  if (!allowedWeekDays) {
    return null
  }
  return Array.isArray(allowedWeekDays) ? allowedWeekDays : allowedWeekDays.split(',')
}

function toMinutes (date) {
  return date.getHours() * 60 + date.getMinutes()
}

function timeToMinutes (time) {
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}

export const mutations = {
  setDuration (state, duration) {
    state.duration = duration
  },
  setDistance (state, distance) {
    state.distance = distance
  },
  setPosition (state, position) {
    if (!state.position || state.position.deviceId === position.deviceId) {
      state.position = position
      state.address = position.address
    }
    Vue.set(state.positions, position.deviceId, position)
  },
  setEta (state, { deviceId, duration, distance }) {
    Vue.set(state.etas, deviceId, { duration, distance })
  },
  SET_DEVICES (state, devices) {
    state.devices = devices
  },
  SET_SESSION (state, session) {
    state.session = session
  },
  SET_CURRENT_TIME (state, currentTime) {
    state.currentTime = currentTime
  }
}

export const actions = {
  async getData ({ commit }) {
    const token = new URLSearchParams(window.location.search).get('token')
    const auth = { username: `temp_${token}`, password: token }
    const positions = await this.$axios.$get('/positions', { auth })
    positions.forEach(p => commit('setPosition', p))
    commit('SET_SESSION', await this.$axios.$get('/session?token=' + token))
    commit('SET_DEVICES', await this.$axios.$get('/devices', { auth }))
  }
}
